exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sau-bx-link .ribbon {\n  right: -9px;\n}\n.sau-bx-link sau-bx p.discount {\n  text-decoration: line-through;\n  color: #d8534f;\n}\n.sau-blaze-blue {\n  background-color: #196AB4;\n}\n.sau-blaze-orange {\n  background-color: #EC7623;\n}\n.sau-enterprise {\n  background-color: #00ce7d;\n}", ""]);

// exports
